import React, {useEffect, useState} from "react";
import {Breadcrumb, ButtonGroup, Card, Table} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CreateTemplate from "./CreateTemplate";
import ViewTemplate from "./ViewTemplate";
import Templates from "./TemplateService";
import {faEdit, faHome, faPlus, faStar, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import CustomSpinner from "../../../components/CustomSpinner";
import {extractPaginationData} from "../../../libs/pagination";
import {Pagination} from "../../../components/Pagination";
import Messages from "../../../components/Messages";
import {messageShown} from "../../../store/reducers/message";
import {useDispatch} from "react-redux";

function TemplateSettings() {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const [templateId, setTemplateId] = useState("");
  const [loading, setLoading] = useState(true);
  const [modal, showModal] = useState(false);
  const [viewModal, showViewModal] = useState(false);
  const [allTemplet, setAllTemplet] = useState([]);
  const [message, setMessage] = useState({show: false, message: '', variant: '', success: false});
  const [refreshData, setRefreshData] = useState(false);
  const [page, setPage] = useState(1);
  const [rowNumber, setRowNumber] = useState(1);
  const [paginationData, setPaginationData] = useState({
    links: [],
    prevPageUrl: "",
    nextPageUrl: "",
    showingPerPage: "",
    total: ""
  });


  useEffect(() => {
    setLoading(false);
    let AllData = Templates.getTemplates();
    setAllTemplet(AllData);
  }, []);


  useEffect(() => {
    getPaginatedTemplates(page);
  }, [page]);

  useEffect(() => {
    if (refreshData) {
      getPaginatedTemplates();
      setRefreshData(false);
    }
  }, [refreshData]);

  useEffect(() => {
    if (message.show) {
      const timer = setTimeout(() => {
        setMessage({show: false, message: '', variant: '', success: false});
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);


  const getPaginatedTemplates = (page = null) => {
    setLoading(true);
    Templates.getPaginatedTemplates(page)
      .then(res => {
        setLoading(false);
        if (res.templates) {
          setAllTemplet(res.templates.data);
          setPaginationData(extractPaginationData(res.templates));
          setRowNumber((res.templates.current_page * res.templates.per_page + 1) - res.templates.per_page)
        } else {
            dispatch(messageShown({show: true, message: res.message || '', success: false, variant: "warning"}));
        }
      })
  }

  const deleteTemplate = async (id) => {
    let deleteTemplate = await Templates.deleteTemplates(id);
    if (deleteTemplate.success) {
      setRefreshData(true);
        dispatch(messageShown({show: true, message: deleteTemplate.message, success: true, variant: "success"}))
    } else {
        dispatch(messageShown({show: true, message: deleteTemplate?.message || '', success: false, variant: "warning"}))
    }
  }
  
  

  const Setdefault = async (id) => {
    let updateStatus = await Templates.setDefaultTemplate(id);
    if (updateStatus.success) {
      setRefreshData(true);
        dispatch(messageShown({show: true, message: updateStatus.message, success: updateStatus.success, variant: "success"}))
    } else {
        dispatch(messageShown({show: true, message: updateStatus && updateStatus.message, variant: "warning"}))
    }
  }

  const TableRow = (props) => {
    return (
      <tr>
        <td>
          <span className="fw-normal">{props.index + rowNumber}</span>
        </td>
        <td colSpan="4" style={{cursor: "pointer"}} onClick={() => {
          showViewModal(true);
          setTemplateId(props.id);
        }}>
          <span className="fw-normal">{props.name}</span>
        </td>
        <td>
          <span className="fw-normal ">
          <div className="btn  btn-sm me-2"
               onClick={() => Setdefault(props.id)}>
              <FontAwesomeIcon icon={faStar} color={props.is_default ? "black" : "grey"}/>
            </div>
            <div
              className="btn btn-outline-primary btn-sm me-2"
              onClick={() => {
                setTemplateId(props.id);
                showModal(true);
              }}
            >
              <FontAwesomeIcon icon={faEdit}/>
            </div>
            <div className="btn btn-outline-primary btn-sm me-2"
                 onClick={() => deleteTemplate(props.id)}><FontAwesomeIcon icon={faTrashAlt}/> </div>
          </span>
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{className: "breadcrumb-dark breadcrumb-transparent"}}
          >
            <Breadcrumb.Item href="/">
              <FontAwesomeIcon icon={faHome}/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{t("Templates")}</Breadcrumb.Item>
          </Breadcrumb>
          <h4>{t("Templates")}</h4>
          <p className="mb-0">{t("Showing all Templates")}</p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <div
              className="btn btn-outline-primary btn-sm"
              onClick={() => {
                setTemplateId("");
                showModal(true);
              }}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2"/> {t("new")}
            </div>
          </ButtonGroup>
        </div>
      </div>

    <div className="row">
        <div className="col-md-12">
            <Messages/>
        </div>
    </div>
      {loading ? <CustomSpinner/> :

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="pt-0 pb-5">
          <Table hover className="user-table align-items-center">
            <thead>
            <tr>
              <th className="border-bottom">#</th>
              <th className="border-bottom">{t("Name")}</th>
              <th className="border-bottom"></th>
              <th className="border-bottom"></th>
              <th className="border-bottom"></th>
              <th className="border-bottom">{t("action")}</th>
            </tr>
            </thead>
            <tbody>
            {allTemplet && allTemplet.length > 0 &&
              allTemplet.map((template, index) => (
                <TableRow
                  key={`template-${index}`}
                  index={index}
                  {...template}
                />
              ))}
            </tbody>
          </Table>
        </Card.Body>

        <Pagination page={page} setPage={setPage} {...paginationData} />

        <CreateTemplate
          show={modal}
          templateId={templateId}
          handleClose={() => showModal(false)}
          setModalMessage={(data) => {
            setMessage(data);
          }}
          setRefreshData={setRefreshData}
        />
        <ViewTemplate
          show={viewModal}
          TemplateId={templateId}
          handleClose={() => showViewModal(false)}
        />
      </Card>}
    </>
  );
}

export default TemplateSettings;
